<template>
  <RouterView />
</template>

<script setup>
import { RouterView } from 'vue-router';
import { useAuthStore } from './stores/authStore';
import { onMounted } from 'vue';

const authStore = useAuthStore();

// Check authentication when app loads
onMounted(() => {
  if (!authStore.isAuthenticated && !window.location.pathname.includes('/login')) {
    window.location.href = '/login';
  }
});
</script>